import { render, staticRenderFns } from "./SearchTrigger.vue?vue&type=template&id=68d1c0a2&"
import script from "./SearchTrigger.vue?vue&type=script&lang=js&"
export * from "./SearchTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports